import { ItemType } from 'modules/help'

export const accordion = [
  {
    id: 'faq-0',
    title: 'Como funciona a liberação de valores no Financiamento para Construção?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `A liberação funciona de acordo com a evolução da obra. Isso acontece porque é preciso 
        atingir percentuais de obra física concluída para que novas liberações sejam validadas.`
      }
    ]
  },
  {
    id: 'faq-1',
    title: 'Como funciona a validação de atingimento percentual da obra física concluída?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `A validação é feita por meio de vistoria presencial. Temos uma equipe focada em 
        receber as solicitações de medição e engenheiros para visitarem a obra e verificarem o 
        percentual atingido.`
      }
    ]
  },
  {
    id: 'faq-2',
    title: 'Quais são os documentos necessários para o financiamento de construção?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Os documentos necessários são: matrícula do terreno e IPTU do ano vigente, projeto e 
        alvará com aprovação da prefeitura do município, ART (Anotação de Responsabilidade Técnica) da 
        execução da obra e, se houver, perspectiva do projeto. Além dos documentos, você precisará 
        preencher a ficha cadastral e o orçamento da CashMe.`
      }
    ]
  },
  {
    id: 'faq-3',
    title: 'Preciso que meu projeto de obra esteja aprovado na prefeitura?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Sim, é necessário que o seu projeto de construção esteja aprovado pela prefeitura, e 
        que ele tenha o valor mínimo de R$ 500 mil. Esse valor mínimo é referente à soma do valores do 
        terreno e da obra.`
      }
    ]
  },
  {
    id: 'faq-4',
    title: 'Como funciona o pagamento das minhas parcelas?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `O pagamento das parcelas é feito de acordo com as liberações dos valores de contrato. 
        Por exemplo: Você tem um contrato de R$ 1 milhão dividido em 4 liberações de R$ 250 mil. Na 
        primeira liberação, você paga o referente a R$ 250 mil. A partir da segunda liberação, você 
        paga o referente a R$ 500 mil, e segue dessa forma até a última liberação.`
      }
    ]
  },
  {
    id: 'faq-5',
    title: 'O que é Habite-se? Eu preciso ter esse documento ao final da minha obra?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `O Habite-Se é um documento que atesta que o projeto foi realizado de acordo com as 
        normas estabelecidas pela prefeitura. Ele é obrigatório por lei e extremamente relevante para 
        provar as condições de segurança e habitação. Sua ausência torna o imóvel irregular e pode 
        acarretar penalidades. Por isso, é preciso ter o documento ao final da sua obra.`
      }
    ]
  }
]
